import React from 'react'
import { Box, Typography } from '@mui/material'
import TextContainer from './TextContainer'
import { ICON_COLOR, UNDERLINE_ACCENT_COLOR } from '../colorPalette';

function SectionBanner2({customStyles, text, IconComponent}) {
    return (
        <Box sx={{ marginTop: '50px', marginBottom: '15px', ...customStyles}}>
            <TextContainer customStyles={{display: 'flex', flexDirection: 'row'}}>
                <Box sx={{alignContent: 'center'}}>
                    {IconComponent && <IconComponent sx={{ fontSize: '24px', color: ICON_COLOR }} />}
                </Box>
                <Box sx={{marginLeft: '10px', alignContent: 'center', width: '100%'}}>
                    <Typography variant='body1' sx={{fontWeight: 'Medium', color: '#484848'}}>{text}</Typography>
                    <Box sx={{marginTop: '5px', height: '1px', width: '100%', backgroundColor: UNDERLINE_ACCENT_COLOR}}></Box>
                </Box>
            </TextContainer>
        </Box>
    )
}

export default SectionBanner2